import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DPO_CONSTANT } from './../../utils/constant';
import { SubscriptionValidateDialogBoxComponent } from './../subscription-validate-dialog-box/subscription-validate-dialog-box.component';
import { DatePipe } from './../../pipes/date.pipe';
import { SubscriptionService } from './../../services/subscription.service';
import { CacheService } from './../../services/cache.service';
import { HttpService } from './../../services/http.service';
import { AuthenticationService } from './../../services/authentication.service';
import { NgxSpinnerService } from "ngx-spinner";
/* CAP-20457 : DAAS-42 : Start - Imported packages */
import { element } from 'protractor';
/* CAP-20457 : DAAS-42 : End */
import { TranslateService } from '@ngx-translate/core';   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON

declare function submitCallbackForm(): any;

@Component({
  selector: 'dpo-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {

  // Define the properties of the component.
  userRole: string;
  userRoles: string;
  userId: string;
  applicationName: string;                // CAP-20753 : Added applicationName as string
  userType: string;                       // CAP-20753 : Added userType as string
  payerType: string;                      // CAP-20753 : Added payerType as string
  subscriptionAreaTemp1: any = {};         // CAP-20457 : DAAS-42 : variable declaration
  subscriptionAreaTemp: any = {};          // CAP-20457 : DAAS-42 : variable declaration
  DPO_CONSTANT = DPO_CONSTANT;

  currentSubscriptionList: Array<any> = [];
  subscriptionAreaList: Array<any> = [];
  saveSubscriptionList: Array<any> = [];

  rrdiEngineResult: any = {};
  warrantyCampaignResult: any = {};
  currentSubscriptionResult: any = {};
  subscriptionAreaResult: any = {};

  curentSubscriptionDisplayedColumns: string[] = ['prestation', 'ecu', 'billable', 'subscriptionDate', 'subscriptionLabel'];
  subscriptionAreaDisplayedColumns: string[] = ['action', 'prestation', 'billable', 'quantity', 'subscriptionLabel'];
  curentSubscriptionDataSource = new MatTableDataSource(this.currentSubscriptionList);
  subscriptionAreaDataSource = new MatTableDataSource(this.subscriptionAreaList);
  @ViewChild('currentSubscriptionPaginator', { static: true }) currentSubscriptionPaginator: MatPaginator;
  @ViewChild('subscriptionAreaPaginator', { static: true }) subscriptionAreaPaginator: MatPaginator;
  @ViewChild('currentSubscriptionSort', { static: true }) currentSubscriptionSort: MatSort;
  @ViewChild('subscriptionAreaSort', { static: true }) subscriptionAreaSort: MatSort;

  queryParams: any;

  rrdi: string;
  vin: string;
  rrdiBrand: string;
  vinBrand: string;
  mileage: string;
  folderId: string;
  callbackUrl: string;
  languageId: string;
  campaign: string;
  warrantyEndDate: string;

  rrdiViewValue: string;
  vinViewValue: string;
  campaignViewValue: string;
  warrantyEndDateViewValue: string;

  STATUS_ONE = 1;
  STATUS_TWO = 2;
  STATUS_THREE = 3;
  STATUS_FOUR = 4;
  STATUS_FIVE = 5;

  checkboxCount: number = 0;
  quantityValue: string;
  /*CAP-20457: start -- Parameters for data binding - language */
  langcode: string;
  instrl1: string = '';
  instrl2: string = '';
  instrl3: string = '';
  isARLanguage: boolean;
  isOtherLanguage: boolean; 
  /*CAP-20457 : End */
  jsonString: string;
   warrantyEndDatefrgetSubscriptions: string;
   dpoLanguage:string;
   dpoPage:string;
   quantity:number=0;
   // CAP-20457 : DAAS-42 : Added TranslatePipe to support translation
  constructor(private subscriptionService: SubscriptionService,
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private cacheService: CacheService,
    private translate1:TranslateService,   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
    private matDialog: MatDialog,
    private httpService: HttpService,
    private authenticationService: AuthenticationService,
    private SpinnerService: NgxSpinnerService) { }

  ngOnInit() {
    // Get the user's information
    this.userRoles = this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ROLES);
    this.userRole = this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ROLE);
    this.userId = this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_ID);
    /* CAP-20753 : Start - applicationName and UserType for getting info */
    this.applicationName = this.cacheService.getItem(DPO_CONSTANT.CACHE_APPLICATION_NAME);
    this.userType = this.cacheService.getItem(DPO_CONSTANT.CACHE_USER_TYPE);
    /* CAP-20753 : End */
    this.dpoLanguage = this.cacheService.getItem(DPO_CONSTANT.CACHE_DPO_LANG);
    console.log("The subscription ts file has dpolang :" + this.dpoLanguage);
    /*CAP-20457: START -- Binding process for language instructions */
    //this.langcode= this.cacheService.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE);
    this.langcode= localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE);    //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
    console.log("language code for changes in binding is : "+ this.langcode);
    if(this.langcode === 'ar-AE') {
      this.isARLanguage = true;
      this.isOtherLanguage=false;
    } else {
      this.isARLanguage = false;
      this.isOtherLanguage = true;
    }
    /*CAP-20457-- End*/
    this.dpoPage = this.cacheService.getItem(DPO_CONSTANT.CACHE_PAGE_FLAG);
    // Intialize the table
    this.intializeCurentSubscriptionTable();
    this.intializeSubscriptionAreaTable();
    // Fetch all the available query parameters from URL
    this.queryParams = this.cacheService.getItem(DPO_CONSTANT.CACHE_QUERY_PARAMS);
    if (this.queryParams) {
      if (this.queryParams[DPO_CONSTANT.QP_RRDI_CODE]) {
        if (this.queryParams[DPO_CONSTANT.QP_RRDI_CODE] != '' && this.queryParams[DPO_CONSTANT.QP_RRDI_CODE] != 'null' && this.queryParams[DPO_CONSTANT.QP_RRDI_CODE] != 'NULL') {
        this.rrdi = this.queryParams[DPO_CONSTANT.QP_RRDI_CODE];
        }
      }
      if (this.queryParams[DPO_CONSTANT.QP_VIN]) {
        if (this.queryParams[DPO_CONSTANT.QP_VIN] != '' && this.queryParams[DPO_CONSTANT.QP_VIN] != 'null' && this.queryParams[DPO_CONSTANT.QP_VIN] != 'NULL') {
        this.vin = this.queryParams[DPO_CONSTANT.QP_VIN];
      }
    }
      if (this.queryParams[DPO_CONSTANT.QP_RRDI_BRAND]) {
        if (this.queryParams[DPO_CONSTANT.QP_RRDI_BRAND] != '' && this.queryParams[DPO_CONSTANT.QP_RRDI_BRAND] != 'null' && this.queryParams[DPO_CONSTANT.QP_RRDI_BRAND] != 'NULL') {
        this.rrdiBrand = this.queryParams[DPO_CONSTANT.QP_RRDI_BRAND];
      }
    }
      if (this.queryParams[DPO_CONSTANT.QP_VIN_BRAND]) {
        if (this.queryParams[DPO_CONSTANT.QP_VIN_BRAND] != '' && this.queryParams[DPO_CONSTANT.QP_VIN_BRAND] != 'null' && this.queryParams[DPO_CONSTANT.QP_VIN_BRAND] != 'NULL') {
        this.vinBrand = this.queryParams[DPO_CONSTANT.QP_VIN_BRAND];
      }
    }
      if (this.queryParams[DPO_CONSTANT.QP_MILEAGE]) {
        if (this.queryParams[DPO_CONSTANT.QP_MILEAGE] != '' && this.queryParams[DPO_CONSTANT.QP_MILEAGE] != 'null' && this.queryParams[DPO_CONSTANT.QP_MILEAGE] != 'NULL') {
        this.mileage = this.queryParams[DPO_CONSTANT.QP_MILEAGE];
      }
    }
      if (this.queryParams[DPO_CONSTANT.QP_FOLDER_ID]) {
        if (this.queryParams[DPO_CONSTANT.QP_FOLDER_ID] != '' && this.queryParams[DPO_CONSTANT.QP_FOLDER_ID] != 'null' && this.queryParams[DPO_CONSTANT.QP_FOLDER_ID] != 'NULL') {
        this.folderId = this.queryParams[DPO_CONSTANT.QP_FOLDER_ID];
        }
      }
      if (this.queryParams[DPO_CONSTANT.QP_CALLBACK_URL]) {
        if (this.queryParams[DPO_CONSTANT.QP_CALLBACK_URL] != '' && this.queryParams[DPO_CONSTANT.QP_CALLBACK_URL] != 'null' && this.queryParams[DPO_CONSTANT.QP_CALLBACK_URL] != 'NULL') {
        this.callbackUrl = this.queryParams[DPO_CONSTANT.QP_CALLBACK_URL];
        }
      }
      if (this.queryParams[DPO_CONSTANT.QP_LANGUAGE_ID]) {
        this.languageId = this.queryParams[DPO_CONSTANT.QP_LANGUAGE_ID];
        if ((this.dpoLanguage && this.dpoLanguage=='Y')||(this.dpoPage && this.dpoPage=='C')) {    
        console.log("The language passed in ifelse 1:" + this.cacheService.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE)); 
        //this.translationService.loadTranlationForLocale(this.cacheService.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE));
        this.translate1.use(localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE));
        this.cacheService.setItem(DPO_CONSTANT.CACHE_DPO_LANG,'N');
        this.cacheService.setItem(DPO_CONSTANT.CACHE_PAGE_FLAG,'S');
        console.log("The language passed in ifelse 2:" + this.cacheService.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE));
        }else {
          console.log("The language passed in ifelse 3 :" + this.languageId);
          //CAP-20457: LOT1.1: START -  Translation Service changed to translate for JSON
          let slocale = this.authenticationService.loadDefaultLocale(this.languageId);
          this.translate1.use(slocale);
          localStorage.setItem(DPO_CONSTANT.CACHE_I18N_LOCALE, slocale);
	  //CAP-20457: LOT1.1: STOP - Translation Service changed to translate for JSON
        }
      }
      if (this.queryParams[DPO_CONSTANT.QP_CAMPAIGN]) {
        if (this.queryParams[DPO_CONSTANT.QP_CAMPAIGN] != '' && this.queryParams[DPO_CONSTANT.QP_CAMPAIGN] != 'null' && this.queryParams[DPO_CONSTANT.QP_CAMPAIGN] != 'NULL') {
          this.campaign = this.queryParams[DPO_CONSTANT.QP_CAMPAIGN];
        }
      }
      if (this.queryParams[DPO_CONSTANT.QP_WARRANTY_END_DATE] || this.applicationName.toLowerCase() === DPO_CONSTANT.POI) {
        // CAP-20753 : Checking for the applicationName as poi for warrantyEndDatefrgetSubscriptions as NA
        if(this.applicationName.toLowerCase() === DPO_CONSTANT.POI){
            this.warrantyEndDatefrgetSubscriptions = DPO_CONSTANT.NA;
          } 
      else if (this.queryParams[DPO_CONSTANT.QP_WARRANTY_END_DATE] != '' && this.queryParams[DPO_CONSTANT.QP_WARRANTY_END_DATE] != 'null' ) {
          this.warrantyEndDate = this.queryParams[DPO_CONSTANT.QP_WARRANTY_END_DATE];
          this.warrantyEndDatefrgetSubscriptions = this.queryParams[DPO_CONSTANT.QP_WARRANTY_END_DATE];
        }       
      }
    }

    // Remove duplicate calls for API
    let currentUrl = window.location.href.split('/#')[1];
    if (currentUrl === '/' + DPO_CONSTANT.PATH_SUBSCRIPTION) {
  
      /* CAP-20753 : Start */ 
      if(this.userRole.toUpperCase() === "DPO.PORT_TECH_USER" || this.userRole.toLowerCase() === "ri_user"){
        console.log(this.authenticationService.rrdiEngineResult);
      if(this.authenticationService.rrdiEngineResult) {
        this.payerType = this.authenticationService.rrdiEngineResult.payerType;   // CAP-20753 : Assigning payerType
        this.rrdi = this.authenticationService.rrdiEngineResult.rrdi;
        this.rrdiViewValue = this.rrdi;
        this.vinViewValue = this.vin;
        // Intialize check for warranty and campaign info
        this.processWarrantyAndCampaign();
      }
      }
      else {
        console.time("Time for RRDI Search");
        this.getRrdiEngine();
        console.timeEnd("Time for RRDI Search"); 
      }
    }
  } 
  /* CAP-20753 : End */ 

  // Intilize current subscription table to it's intial state
  intializeCurentSubscriptionTable() {
    this.curentSubscriptionDataSource = new MatTableDataSource(this.currentSubscriptionList);
    this.curentSubscriptionDataSource.paginator = this.currentSubscriptionPaginator;
    this.curentSubscriptionDataSource.sort = this.currentSubscriptionSort;
  }

  // Intilize subscription features table to it's intial state
  intializeSubscriptionAreaTable() {
    this.subscriptionAreaDataSource = new MatTableDataSource(this.subscriptionAreaList);
    this.subscriptionAreaDataSource.paginator = this.subscriptionAreaPaginator;
    this.subscriptionAreaDataSource.sort = this.subscriptionAreaSort;
  }

  // Method to call the RRDI engine
  getRrdiEngine() {
    // Prepare the parameter for the RRDI engine API
    let params: any = {
      rrdi: this.rrdi ? this.rrdi.trim() : '',
      brand: this.vinBrand ? this.vinBrand.trim() : '',
      userId: this.userId ? this.userId.trim() : '',
      userRoles: this.userRoles,
      applicationName: this.applicationName,            // CAP-20753 : Added applicationName as params 
      userType: this.userType                       // CAP-20753 : Added userType as params 

    };
    // Call the RRDI engine API with defined parameters
    this.SpinnerService.show();  
    this.subscriptionService.getRrdiByEngine(params)
      .subscribe(response => {
        this.rrdiEngineResult = response;
        //CAP-20457: LOT1.1: Sequential flow - synchronise call
        if (Object.keys(this.rrdiEngineResult).length !== 0 || this.rrdiEngineResult!=null && this.rrdiEngineResult!='') {
          //Assigning value to payerType recieved in response 
          this.payerType = this.rrdiEngineResult.payerType;   // CAP-20753 : Assigned value to payerType
          this.rrdi = this.rrdiEngineResult.rrdi;
          this.rrdiViewValue = this.rrdi;
          this.vinViewValue = this.vin;
          // Intialize check for warranty and campaign info
          this.processWarrantyAndCampaign();         
        }
        this.SpinnerService.hide(); 
      }, error => {
        this.SpinnerService.hide(); 
        if (error && error.status && error.status === 404 && error.error) {
          this.toastrService.warning(this.translate1.instant(error.error), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        } else {
          this.toastrService.error(this.translate1.instant('dpo.i18n.message.record.error'), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
      });
  }

  // Method to check or call the API for warranty and campaign information
  processWarrantyAndCampaign() {
    if (this.warrantyEndDate && this.campaign && this.warrantyEndDate != '' && this.campaign != '') {
      this.warrantyEndDateViewValue = this.warrantyEndDate;       
      this.campaignViewValue = 'dpo.i18n.label.subscription.bill.yes';    // CAP-20457 : Translation added + //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
      // Fetch the table's data
      this.fetchTableData();
    } else {
      // Fetch the warranty and campaign from API
      this.getWarrantyAndCampaign();
//this.fetchTableData();   //To be applied later while merging the code
    }
  }

  // Method to call warranty and campaign info
  getWarrantyAndCampaign() {
    // Prepare the parameters for API
    let params: any = {
      rrdi: this.rrdi ? this.rrdi.trim() : '',
      vin: this.vin ? this.vin.trim() : '',
      brand: this.vinBrand ? this.vinBrand.trim() : '',
      mileage: this.mileage ? this.mileage.trim() : '',
      language: this.languageId ? this.languageId.trim() : '',
      warrantyEndDate: this.warrantyEndDate,
      campaign: this.campaign ? this.campaign.trim() : '',
      applicationName: this.applicationName,    // Cap-20753 : Added applicationName as param
      userId: this.userId,                      // Cap-20753 : Added userId as param
    };
    // Call the API to get warranty and campaign with defined parameters
    this.SpinnerService.show();  
    this.subscriptionService.getWarrantyAndCampaign(params)
      .subscribe(response => {
        this.warrantyCampaignResult = response;
        //CAP-20457: LOT1.1: Sequential flow - synchronise call
        if (this.warrantyCampaignResult!=null) {
          if(this.warrantyCampaignResult.warrantyEndDate === 'dpo.i18n.order.warranty.campaign.val') {
            this.warrantyEndDate = this.translate1.instant(this.warrantyCampaignResult.warrantyEndDate);
          } else {
            this.warrantyEndDate = this.datePipe.transform(this.warrantyCampaignResult.warrantyEndDate);
          }
          this.warrantyEndDateViewValue = this.warrantyEndDate;
          this.campaign = this.warrantyCampaignResult.campaignCode;
          /* CAP-20457 :Start -  Translation related changes for Campaign In Progress */
          if ((this.warrantyCampaignResult.campaignInProgress || this.warrantyCampaignResult.campaignInProgress != '') && this.warrantyCampaignResult.campaignInProgress === 'dpo.i18n.label.subscription.bill.yes') {
            this.campaignViewValue = 'dpo.i18n.label.subscription.bill.yes';   // CAP-20457 : Translation added //this.warrantyCampaignResult.campaignInProgress; + //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
          }
          else if ((this.warrantyCampaignResult.campaignInProgress || this.warrantyCampaignResult.campaignInProgress != '') && this.warrantyCampaignResult.campaignInProgress === 'dpo.i18n.label.subscription.bill.no') {
            this.campaignViewValue = 'dpo.i18n.label.subscription.bill.no';     // CAP-20457 : Translation added //this.warrantyCampaignResult.campaignInProgress; + //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
          }
          else {
            this.campaignViewValue = this.warrantyCampaignResult.campaignInProgress;
          }
          /* CAP-20457 : End */
          // Fetch the table's data
          this.fetchTableData();
        }
      //  this.SpinnerService.hide(); 
      }, error => {
        this.SpinnerService.hide(); 
        if (error && error.status && error.status === 404 && error.error) {
          this.toastrService.warning(this.translate1.instant(error.error), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        } else {
          this.toastrService.error(this.translate1.instant('dpo.i18n.message.record.error'), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
      });
  }

  // Method to call the API for current subscription and subscreition feature
  fetchTableData() {
    this.getCurrentSusbcription();
    this.getSubscribedFeatures();
  }

  // Method to call the API for current subscription
  getCurrentSusbcription() {
    this.curentSubscriptionDataSource.data.splice(0, this.currentSubscriptionList.length);
    // Prepare the parameter for API
    let params: any = {
      rrdi: this.rrdi ? this.rrdi.trim() : '',
      vin: this.vin ? this.vin.trim() : '',
      userRoles: this.userRoles
    };
    // Call teh current subscription API
    this.SpinnerService.show(); 
    this.subscriptionService.getCurrentSubscription(params)
      .subscribe(response => {
      /* CAP-20457 : DAAS-42 : Start -Translation for subscription label in result*/
        this.subscriptionAreaTemp1 = response;
        console.log(this.subscriptionAreaTemp);
        //CAP-20457: LOT1.1: START - Sequential flow - synchronise call
        // if(Object.keys(this.subscriptionAreaTemp1).length !== 0) {
        //   this.getSubscribedFeatures();
        // }
        //CAP-20457: LOT1.1: STOP - Sequential flow - synchronise call
        if(Object.keys(this.subscriptionAreaTemp1).length !== 0){
          this.subscriptionAreaTemp1["subscriptionRepresentations"].forEach(element => {
            //CAP-20457: LOT1.1: START - Translation Service changed to translate for JSON
            if(element.subscriptionLabel!=null && element.subscriptionLabel!='') {
              element.subscriptionLabel = this.translate1.instant(element.subscriptionLabel);
            }
            if(element.prestation!=null && element.prestation!='') {
              element.prestation = this.translate1.instant(element.prestation);
            }
            if(element.ecu!=null && element.ecu!='') {
              element.ecu = this.translate1.instant(element.ecu);
            }
            if(element.billable!=null && element.billable!='') {
              element.billable = this.translate1.instant(element.billable);
            }            
	         //CAP-20457: LOT1.1: STOP - Translation Service changed to translate for JSON
          });
         
        }
        this.currentSubscriptionResult = this.subscriptionAreaTemp1;
        console.log(this.currentSubscriptionResult);
       /* CAP-20457 - DAAS-42 : End */
      
        if (Object.keys(this.currentSubscriptionResult).length !== 0) {
          this.currentSubscriptionList = this.currentSubscriptionResult['subscriptionRepresentations'];
          this.intializeCurentSubscriptionTable();
        } else {
          this.toastrService.warning(this.translate1.instant('dpo.i18n.message.record.currentSubsciption.notfound'), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
        this.SpinnerService.hide();
      }, error => {
        this.SpinnerService.hide(); 
        if (error && error.status && error.status === 404 && error.error) {
          this.toastrService.warning(this.translate1.instant(error.error), this.translate1.instant('dpo.i18n.current.warning.msg'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        } else {
          this.toastrService.error(this.translate1.instant('dpo.i18n.message.record.error'), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
      });
  }

  // Method to call the subscription features API
  getSubscribedFeatures() {
    this.subscriptionAreaDataSource.data.splice(0, this.subscriptionAreaList.length);
    // Prepare the parameters for the API call
    let params: any = {
      rrdi: this.rrdi ? this.rrdi.trim() : '',
      vin: this.vin ? this.vin.trim() : '',
      brand: this.vinBrand ? this.vinBrand.trim() : '',
      warrantyEndDate: this.warrantyEndDatefrgetSubscriptions,
      campaign: this.campaign ? this.campaign.trim() : '',
      mileage: this.mileage ? this.mileage.trim() : '',
      language: this.languageId ? this.languageId.trim() : '',
      userType: this.userType                                   // CAP-20753 : Passed paramter userType to get Subscription API
    };
    // Call the subscription features API
    this.SpinnerService.show();  
    this.subscriptionService.getSubscribedFeatures(params)
      .subscribe(response => {
    
       this.subscriptionAreaResult=response;
        if (Object.keys(this.subscriptionAreaResult).length !== 0 || this.subscriptionAreaResult && this.subscriptionAreaResult.length > 0) {
          /* Start  : Changes for later  */
          //this.warrantyEndDate = this.subscriptionAreaResult[0].warrantyEndDate;
          //this.warrantyEndDateViewValue = this.warrantyEndDate;
          //this.campaign = this.subscriptionAreaResult[0].campaignCode;
          //this.campaignViewValue = this.subscriptionAreaResult[0].campaignInProgress;
         // console.log(this.warrantyEndDate + "and "+this.warrantyEndDateViewValue + "and "+this.campaign+"and "+this.campaignViewValue);
          /* End : Changes to be applied later.. */
          this.subscriptionAreaList = this.subscriptionAreaResult;
          for (const subscriptionArea of this.subscriptionAreaList) {
            // Define the default values for checkbox and quantity based on subscription status
            subscriptionArea['checkbox'] = false;
            subscriptionArea['quantity'] = 0;
            if (subscriptionArea.subscriptionLabel === 'dpo.i18n.label.sub.add.op.fu.use') {    // CAP-20457 - Translation added
              subscriptionArea.subscriptionStatus = this.STATUS_ONE;
              subscriptionArea.checkbox = false;
              subscriptionArea.quantity = 1;
            }
            if (subscriptionArea.subscriptionLabel === 'dpo.i18n.label.sub.not.avail') {        // CAP-20457 - Translation added
              subscriptionArea.subscriptionStatus = this.STATUS_TWO;
              subscriptionArea.checkbox = false;
              subscriptionArea.quantity = 0;
            }
            if (subscriptionArea.subscriptionLabel === 'dpo.i18n.label.sub.und.warr.camp') {     // CAP-20457 - Translation added
              subscriptionArea.subscriptionStatus = this.STATUS_THREE;
              subscriptionArea.checkbox = true;
              subscriptionArea.quantity = 1;
              this.updateCheckboxCount(subscriptionArea.checkbox);
            }
            if (subscriptionArea.subscriptionLabel === 'dpo.i18n.label.sub.rrdi.sub') {          // CAP-20457 - Translation added
              subscriptionArea.subscriptionStatus = this.STATUS_FOUR;
              subscriptionArea.checkbox = false;
              subscriptionArea.quantity = 1;
            }
            if (subscriptionArea.subscriptionLabel === 'dpo.i18n.label.sub.wait.conf') {          // CAP-20457 - Translation added
              subscriptionArea.subscriptionStatus = this.STATUS_FIVE;
              subscriptionArea.checkbox = false;
              subscriptionArea.quantity = 1;
            }
          }
          this.intializeSubscriptionAreaTable();
        } else {
          this.toastrService.warning(this.translate1.instant('dpo.i18n.message.record.subscriptionFeature.notfound'), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
        this.SpinnerService.hide();
      }, error => {
        this.SpinnerService.hide(); 
        if (error && error.status && error.status === 404 && error.error) {
          this.toastrService.warning(this.translate1.instant(error.error), this.translate1.instant('dpo.i18n.subscription.warning.msg'), {closeButton: true,});  //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        } else {
          this.toastrService.error(this.translate1.instant('dpo.i18n.message.record.error'), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
      })
  }

  // Method to save the subscription features
  saveSubscription(data: Array<any>) {
    if (data && data.length > 0) {
      // Call API to save the subscription features
      this.subscriptionService.saveSubscription(data).subscribe(response => {
        if (response && response['subscribedList']) {
          this.saveSubscriptionList = response['subscribedList'];
        }
        this.openDialogBox({ source: 'validate' });
      }, error => {
        if (error && error.status && error.status === 404 && error.error) {
          this.toastrService.warning(this.translate1.instant(error.error), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        } else {
          this.toastrService.error(this.translate1.instant('dpo.i18n.message.record.error'), this.translate1.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
      });
    }
  }

  // Method to validate and prepare the data for saving the subscription features
  validateSubscription() {
    let data: Array<any> = [];
    for (const subscriptionArea of this.subscriptionAreaList) {
      if (subscriptionArea.checkbox && subscriptionArea.quantity > 0) {
        let requestData = {};

        //Set from getSubscriptionFeature API response
        requestData['featureId'] = subscriptionArea.featureId;
        requestData['subscriptionId'] = subscriptionArea.subscriptionId;
        requestData['subscriptionRrdiValue'] = subscriptionArea.subscriptionRrdiValue;
        requestData['billable'] = subscriptionArea.billable;
        let applicationName = this.cacheService.getItem(DPO_CONSTANT.CACHE_APPLICATION_NAME);
        if(applicationName.toUpperCase() === DPO_CONSTANT.POI.toUpperCase()) {
                  this.warrantyEndDate = DPO_CONSTANT.NA;
              }
        requestData['warrantyEndDate'] = this.warrantyEndDate;
        requestData['warrantyExtEndDate'] = subscriptionArea.warrantyExtEndDate;

        //Set from getWarrantyAndCampaign API response
        requestData['serviceContract'] = subscriptionArea.serviceContract;

        // Set from query parameters (ServiceBox Request)
        requestData['vin'] = this.vin;
        requestData['folderId'] = this.folderId;
        requestData['panierUrl'] = this.callbackUrl;
        requestData['rrdi'] = this.rrdi;
        
        if(this.campaign === 'dpo.i18n.order.warranty.campaign.val') {
          this.campaign = '';
        }
        requestData['campaignCode'] = this.campaign;
        requestData['userIdUpdate'] = this.userId;

        // Set from UI business logic
        if (this.userRole === DPO_CONSTANT.ROLE_PORT_CCS_MANAGER || this.userRole === DPO_CONSTANT.ROLE_PORT_CCS_USER) {
          requestData['subscriptionMode'] = 'C';
        } else if (this.userRole === DPO_CONSTANT.ROLE_PORT_TECH_USER) {
          requestData['subscriptionMode'] = 'T';
        }

        // Static value for status "Subscribed but not used"
        requestData['subscriptionStatus'] = 1;

        for (let i = 0; i < subscriptionArea.quantity; i++) {
          data.push(requestData);
        }
      }
    }
    this.saveSubscription(data);
  }

  // Method will call if user clicks on cancel subscription button
  cancelSubscription() {
    this.openDialogBox({ source: 'cancel' });
  }

  // Method to open the dialog box
  openDialogBox(data: any) {
    const dialogRef = this.matDialog.open(SubscriptionValidateDialogBoxComponent, {
      width: '500px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.event == 'close') {
          // Nothing to do right now
        }
        if (result.event == 'ok') {
          let callbackSubscriptionList: Array<any> = [];
          for (const subscriptionArea of this.subscriptionAreaList) {
            if (subscriptionArea.checkbox && subscriptionArea.quantity > 0) {
              // Prepare the data for callback URL
              let callbackSubscription = {};
              callbackSubscription['featureId'] = subscriptionArea.featureId;
              callbackSubscription['featureDescription'] = subscriptionArea.prestation;
              callbackSubscription['quantity'] = subscriptionArea.quantity;
              callbackSubscription['priceIndex'] = subscriptionArea.priceIndex;

              callbackSubscriptionList.push(callbackSubscription);
            }
          }
          let params = JSON.stringify({
              folderId: this.folderId,
              subscriptionList: callbackSubscriptionList
            });
          this.openCallbackUrl(params);
          this.authenticationService.reDirectUser();    //CAP-26096_POUDG-8493: Lot-2 related changes
        }
        if (result.event == 'validate') {
          window.close();
          this.authenticationService.unauthenticateUser();
        }
      }
    });
  }

  // Method to execute the callback URL and open the new popup on form submit
  openCallbackUrl(params: any) {
    if (this.userRole === DPO_CONSTANT.ROLE_PORT_CCS_MANAGER || this.userRole === DPO_CONSTANT.ROLE_PORT_CCS_USER) {
      this.jsonString = params;
      submitCallbackForm();
    }
  }

  // Method to validate the quantity
  validateQuantity(value: number) {
    this.quantityValue = '';
    let flag: boolean;
    if (value) {
      let val = new Number(value);
      if (val.valueOf() >= 1 && val.valueOf() <= 10) {
        flag = true;
      } else {
        if (val.valueOf() > 0) {
          this.quantityValue = val.toString().substring(0, 1);
        }
        flag = false;
      }
    }
    return flag;
  }

  // Method to handle the checkbox count
  updateCheckboxCount(value) {
    if (value) {
      this.checkboxCount++;
    } else {
      this.checkboxCount--;
    }
  }

  // Method to check for checkbox count for showing the message or for further processing
  checkCheckboxCount() {
    let flag=false;
    for (const subscriptionArea of this.subscriptionAreaList) {
      if (subscriptionArea.quantity < 0 ||subscriptionArea.quantity==null ) {
        flag=true;
        this.toastrService.warning(this.translate1.instant('dpo.i18n.message.quantity.noSelection'), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
    break;
      }
    }
    if(!flag){
    if (this.checkboxCount === 0) {     
      this.toastrService.warning(this.translate1.instant('dpo.i18n.message.subscription.noSelection'), this.translate1.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
    } else {
      this.validateSubscription();
    
  }
}
  }
 

}
